/**Translation Actions */
export const UPLOAD_FILE = "UPLOAD_FILE"
export const TRANSLATE_DOC = " TRANSLATE_DOC"
export const BATCH_TRANSLATE_DOC = "BATCH_TRANSLATE_DOC"
export const VIEW_BATCH_TRANSLATE_DOC = "VIEW_BATCH_TRANSLATE_DOC"
export const VIEW_DOC = "VIEW_DOC";
export const GLOSSARY_DROP_DOWN = "GLOSSARY_DROP_DOWN";
export const RECENT_TRANSLATIONS = "RECENT_TRANSLATIONS";
export const RECENT_VIEW = "RECENT_VIEW";
export const BATCH_TRANSLATE_DOC_MORE_THAN_20 = "BATCH_TRANSLATE_DOC_MORE_THAN_20";
export const GET_SIGNED_URL = "GET_SIGNED_URL";
export const HTML_FILE_TRANSLATE = "HTML_FILE_TRANSLATE";


/**Auth actions */
export const GOOGLE_LOGIN = "GOOGLE_LOGIN";
export const GOOGLE_AUTH = "GOOGLE_AUTH";
export const EMAIL_LOGIN = "EMAIL_LOGIN";
export const EMAIL_PASSWORD_LOGIN = "EMAIL_PASSWORD_LOGIN"
export const EMAIL_SIGNUP = "EMAIL_SIGNUP";
export const DEMO_SIGNUP = "DEMO_SIGNUP";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const VERIFY_LOGIN = "VERIFY_LOGIN";

/**Portal Actions */
export const PORTAL_LIST = "PORTAL_LIST";
export const PORTAL_VIEW = "PORTAL_VIEW";
export const USERS_DROPDOWN = "USERS_DROPDOWN";
export const PORTAL_CREATE = "PORTAL_CREATE"
export const PORTAL_DELETE = "PORTAL_DELETE"
export const PORTAL_EDIT = "PORTAL_EDIT"
export const ADD_RESOURCE_PORTAL = "ADD_RESOURCE_PORTAL"
export const ADD_USER_PORTAL = "ADD_USER_PORTAL"
export const REMOVE_USER_PORTAL = "REMOVE_USER_PORTAL"
export const GLOSSARY_DROPDOWN = "GLOSSARY_DROPDOWN"
export const REMOVE_GLOSSARY_PORTAL = "REMOVE_GLOSSARY_PORTAL"


/**Users Actions */
export const USER_LIST = "USER_LIST"
export const INVITE_USER = "INVITE_USER"
export const PORTAL_DROPDOWN = "PORTAL_DROPDOWN"
export const USER_VIEW = "USER_VIEW"
export const USER_EDIT = "USER_EDIT"
export const USER_DELETE = "USER_DELETE"
export const LOGIN_TIME_LINE_REPORT = "LOGIN_TIME_LINE_REPORT"
export const REMOVE_PORTAL = "REMOVE_PORTAL"

/**Translation Job Actions */
export const TRANALATIONJOB_LIST = "TRANALATIONJOB_LIST"

/**Resource Actions */
export const UPLOAD_CSV_FILE = "UPLOAD_CSV_FILE"
export const CREATE_GLOSSARY = "CREATE_GLOSSARY"
export const LIST_GLOSSARY = "LIST_GLOSSARY";
export const DELETE_GLOSSARY = "DELETE_GLOSSARY"
export const ASSIGN_PORTAL_GLOSSARY = "ASSIGN_PORTAL_GLOSSARY";
export const PORTALS_DROP_DOWN = "PORTALS_DROP_DOWN";

/**Company Action */
export const COMPANY_REGISTER = "COMPANY_REGISTER"

/**Settings Action */
export const COMPANY_VIEW = "COMPANY_VIEW"
export const COMPANY_EDIT = "COMPANY_EDIT"

/**System Logs Action */
export const SYSTEM_LOGS_LIST = "SYSTEM_LOGS_LIST"
